module.exports = __webpack_public_path__ + "img/dm.708c6f55.svg";